/* eslint-disable */
import {
  Layout,
  Row,
  Col,
  Card,
  Typography,
  Button,
  Space,
  Select,
  DatePicker,
  message,
  Tooltip,
  Drawer,
  Radio,
} from "antd";
import React, { useEffect, useRef, useState,forwardRef, useImperativeHandle} from "react";
import api from "@/utils/api";
import http from "@/utils/http";
import dayjs from "dayjs";
import EnhancedTable from "@/hocComponents/EnhancedTable";
import declineIcon from "@/assets/images/icons/decline.png";
import riseIcon from "@/assets/images/icons/rise.png";
import PropertyBreakdown from "./component/PropertyBreakdown";
import commonFn from "@/utils/commonFn";
import { InfoCircleOutlined } from "@ant-design/icons";
import rentIcon from "@/assets/images/icons/rent.png";
import utilityIcon from "@/assets/images/icons/utility.png";
import otherIcon from "@/assets/images/icons/other.png";
import "./component/index.scss";

const DelinquencyIndex = forwardRef((props, ref) => {
  const { Header, Content } = Layout;
  const { Title } = Typography;
  const { Option } = Select;
  
  const [activeOwnerRecord, setActiveOwnerRecord] = useState(null);
  const [ownerOptions, setOwnerOptions] = useState([]);
  const [selectedOwners, setSelectedOwners] = useState([]);
  const [year, setYear] = useState();
  const [ownerTableList, setOwnerTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [ownerSelectLoading, setOwnerSelectLoading] = useState(false);
  const [showPropertyTable, setShowPropertyTable] = useState(false);
  const [lastUpdatedDate, setLastUpdatedDate] = useState(null);
  const [nextUpdateDate, setNextUpdateDate] = useState(null);
  const currentYear = dayjs().format("YYYY");
  const [dateMode, setDateMode] = useState("year");
  const [period, setPeriod] = useState(currentYear);
  const [activeOwnerId, setActiveOwnerId] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [tableHead, setTableHead] = useState({}); 
  const [supervisorList, setSupervisorList] = useState([]);
  // 统计数据
  const [currentTopSummary, setCurrentTopSummary] = useState(null);
  const [evictionTopSummary, setEvictionTopSummary] = useState(null);
    const isFetching = useRef(false);
  const isInitialized = useRef(false);
  
  // 获取supervisor数据
  const getSupervisorList = async () => {
    const response = await http.get(api.getSupervisorNameDict);
    if (response?.code === "1") {
      const list = (response?.data || []).map((item) => ({
        value: item.accountId,
        label: item.fullName,
      }));
      setSupervisorList(list);
    }
  };
  
  // 合并单元格
  const getMergeCellProps = (record) => ({
    rowSpan: record?._rowSpan ?? 1,
  });

  // 获取分组key
  const getGroupKey = (item = {}) => {
    return `${item.supervisorId || ""}`;
  };

  // 处理数据，添加合并信息
  const getMergedRowData = (list = []) => {
    const nextList = list.map((item) => ({ ...item, _rowSpan: 1 }));

    let startIndex = 0;
    while (startIndex < nextList.length) {
      const currentKey = getGroupKey(nextList[startIndex]);
      let endIndex = startIndex + 1;

      while (
        endIndex < nextList.length &&
        getGroupKey(nextList[endIndex]) === currentKey
      ) {
        endIndex += 1;
      }

      const span = endIndex - startIndex;
      nextList[startIndex]._rowSpan = span;

      for (let i = startIndex + 1; i < endIndex; i++) {
        nextList[i]._rowSpan = 0;
      }

      startIndex = endIndex;
    }

    return nextList;
  };

  // 处理接口数据，转换为表格行数据
  const transformData = (supervisorSummaries) => {
    if (!supervisorSummaries || !Array.isArray(supervisorSummaries)) return [];
    
    const rows = [];
    supervisorSummaries.forEach((item) => {
      // Current Tenant Delinquency 行
      rows.push({
        key: `${item.supervisorId}-current`,
        supervisorId: item.supervisorId,
        supervisorName: item.supervisor,
        rowType: 'current',
        rowLabel: 'Total Current Tenant Delinquency',
        units: item.currentSummary?.units || 0,
        current: commonFn.amountToDollarBracketFn(item.currentSummary?.current || 0),
        days30: commonFn.amountToDollarBracketFn(item.currentSummary?.days30 || 0),
        days60: commonFn.amountToDollarBracketFn(item.currentSummary?.days60 || 0),
        days90Plus: commonFn.amountToDollarBracketFn(item.currentSummary?.days90Plus || 0),
        total: commonFn.amountToDollarBracketFn(item.currentSummary?.total || 0),
        pctOfTotalDelinquency: item.currentSummary?.pctOfTotalDelinquency 
          ? `${Number(item.currentSummary.pctOfTotalDelinquency).toFixed(2)}%` 
          : '',
        rawData: item.currentSummary,
        owner_id: item.supervisorId,
        owner_name: item.supervisor,
      });
      
      // Current In Eviction Delinquency 行
      rows.push({
        key: `${item.supervisorId}-eviction`,
        supervisorId: item.supervisorId,
        supervisorName: item.supervisor,
        rowType: 'eviction',
        rowLabel: 'Total Current In Eviction Delinquency',
        units: item.evictionSummary?.units || 0,
        current: commonFn.amountToDollarBracketFn(item.evictionSummary?.current || 0),
        days30: commonFn.amountToDollarBracketFn(item.evictionSummary?.days30 || 0),
        days60: commonFn.amountToDollarBracketFn(item.evictionSummary?.days60 || 0),
        days90Plus: commonFn.amountToDollarBracketFn(item.evictionSummary?.days90Plus || 0),
        total: commonFn.amountToDollarBracketFn(item.evictionSummary?.total || 0),
        pctOfTotalDelinquency: item.evictionSummary?.pctOfTotalDelinquency 
          ? `${Number(item.evictionSummary.pctOfTotalDelinquency).toFixed(2)}%` 
          : '',
        rawData: item.evictionSummary,
        owner_id: item.supervisorId,
        owner_name: item.supervisor,
      });
    });
    
    // 应用合并
    return getMergedRowData(rows);
  };

  // 列配置 
  const columns = [
    {
      title: "Supervisor Name",
      dataIndex: "supervisorName",
      width: 180,
      onCell: (record) => getMergeCellProps(record),
      render: (text, record) => {
        if (record?._rowSpan > 0) {
          const highlightId = record.supervisorId;
          return (
            <Button
              type="link"
              className={`owner-total-link ${
                activeOwnerId === highlightId ? "owner-total-link-active" : ""
              }`}
              onClick={() => {
                handleTotalClick(record);
              }}
            >
              {text}
            </Button>
          );
        }
        return null;
      },
    },
    {
      title: "",
      titleType: "text", 
      dataIndex: "rowLabel",
      width: 280,
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Units",
      dataIndex: "units",
      render: (value) => value.toLocaleString(),
    },
    {
      title: "Current(<30)",
      dataIndex: "current",
    },
    {
      title: "30 Days",
      dataIndex: "days30",
    },
    {
      title: "60 Days",
      dataIndex: "days60",
    },
    {
      title: "90+ Days",
      dataIndex: "days90Plus",
    },
    {
      title: "Total",
      dataIndex: "total",
    },
    {
      title: "% of Total Delinquency",
      dataIndex: "pctOfTotalDelinquency",
    },
  ];

  const handleTotalClick = (record) => {
    if (!period) {
      message.warning("Please select year first");
      return;
    }

    const rawOwnerId = record.supervisorId;
    const highlightId = rawOwnerId ?? "__ALL__";

    setShowPropertyTable(true);
    setActiveOwnerId(highlightId);
    setActiveOwnerRecord(record);
  };

  const fetchTable = async (supervisorId = null) => {
      if (isFetching.current) return;
    isFetching.current = true;
    setTableLoading(true);
    try {
      const params = {};
      if (supervisorId) {
        params.supervisorId = supervisorId;
      }
      
      const response = await http.get(api.getDelinquencyShow, { params });
      if (response?.code === "1") {
        const { supervisorSummaries, currentTopSummary, evictionTopSummary } = response?.data || {};
        const transformedData = transformData(supervisorSummaries || []);
        setOwnerTableList(transformedData);
        setFilteredData(transformedData);
        setCurrentTopSummary(currentTopSummary);
        setEvictionTopSummary(evictionTopSummary);
      } else {
        console.log("getOwnerData error:", response);
        setOwnerTableList([]);
        setFilteredData([]);
        message.error(response?.msg);
      }
    } catch (e) {
      console.error(e);
      setOwnerTableList([]);
      setFilteredData([]);
    } finally {
      setTableLoading(false);
       isFetching.current = false;
    }
  };

  const handleClose = () => {
    setShowPropertyTable(false);
  };
  // useImperativeHandle(ref, () => ({
  //   refresh() {
  //     if (isInitialized.current && !isFetching.current) {
  //       fetchTable(tableHead.supervisorId || null);
  //     }
  //   }
  // }));
useImperativeHandle(ref, () => ({
  refresh() {
    if (!isFetching.current) {
      fetchTable(tableHead.supervisorId || null);
    }
  }
}));
  useEffect(() => {
    fetchTable();
    getSupervisorList();
  }, []);

  const renderStatCards = () => {
    const currentData = currentTopSummary || {};
    const evictionData = evictionTopSummary || {};
    const agingItems = [
      { label: "Current(< 30)", key: "current", className: "current" },
      { label: "30 Days", key: "days30", className: "days30" },
      { label: "60 Days", key: "days60", className: "days60" },
      { label: "90+ Days", key: "days90Plus", className: "days90" },
    ];
    const categoryItems = [
      { label: "Rent", key: "rent", icon: rentIcon },
      { label: "Utility", key: "utility", icon: utilityIcon },
      { label: "Other", key: "other", icon: otherIcon },
    ];
    const renderCardContent = (title, data) => (
      <Row gutter={16} className="stat-card-inner">
        <Col span={16} className="stat-card-main-col">
          <div className="stat-card-label">{title}</div>
          <div className="stat-card-amount">
            {commonFn.amountToDollarBracketFn(data.total || 0)}
          </div>
          <div className="stat-card-units">
            <span>{data.units || 0}</span>
            <span className="stat-card-units-label"> Units</span>
          </div>
          <div className="stat-aging-list">
            {agingItems.map((item) => (
              <div className="stat-aging-item" key={item.key}>
                <div className="stat-aging-label">
                  <span className={`stat-aging-dot stat-aging-dot-${item.className}`} />
                  <span>{item.label}</span>
                </div>
                <div className="stat-aging-value">
                  {commonFn.amountToDollarBracketFn(data[item.key] || 0)}
                </div>
              </div>
            ))}
          </div>
        </Col>
        <Col span={8} className="stat-card-side-col">
          <div className="stat-side-total">
            <div className="stat-side-amount">
              {commonFn.amountToDollarBracketFn(data.total || 0)}
            </div>
            <div className="stat-side-caption">Details of tenant arrears</div>
          </div>
          <div className="stat-category-list">
            {categoryItems.map((item) => (
              <div className="stat-category-item" key={item.key}>
                <img src={item.icon} alt={item.label} className="stat-item-icon" />
                <span className="stat-category-label">{item.label}</span>
                <span className="stat-category-value">
                  {commonFn.amountToDollarBracketFn(data[item.key] || 0)}
                </span>
              </div>
            ))}
          </div>
        </Col>
      </Row>
    );

    return (
      <Row gutter={16} className="stat-cards-row">
        <Col span={12}>
          <Card className="stat-card" bordered={false}>
            {renderCardContent("Total Current Tenant Delinquency", currentData)}
          </Card>
        </Col>
        <Col span={12}>
          <Card className="stat-card" bordered={false}>
            {renderCardContent("Total Current In Eviction Delinquency", evictionData)}
          </Card>
        </Col>
      </Row>
    );
  };

return (
    <div className="dashboard-layout-Delinquency">
      <Content className="dashboard-content-Delinquency">
        {renderStatCards()}

        <div className="financial-table-container-Delinquency">
          <div style={{ 
            marginBottom: 8,
            display: 'flex',
            justifyContent: 'flex-start',
          }}>
            <Select
              placeholder="Search Supervisor"
              style={{ width: 180 }}
              allowClear
              showSearch
              optionFilterProp="label"
              value={tableHead.supervisorId}
              onChange={(value) => {
                setTableHead({ supervisorId: value });
                fetchTable(value);
              }}
              onClear={() => {
                setTableHead({});
                fetchTable(null);
              }}
              options={supervisorList}
            />
          </div>
          
          <EnhancedTable 
            loading={tableLoading}
            columns={columns}
            dataSource={filteredData}
            scroll={{ y: "calc(100vh - 480px)" }}
            rowKey="key"
            pagination={false}
          />
        </div>

        <Drawer
          placement="bottom"
          open={showPropertyTable}
          onClose={handleClose}
          height="100%"
          closable={false}
          title={null}
          getContainer={false}
          mask={false}
          style={{
            padding: 0,
            overflow: "visible",
            position: "absolute",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <PropertyBreakdown
              supervisorId={activeOwnerId}
              supervisorName={activeOwnerRecord?.supervisorName}
              ownerRecord={activeOwnerRecord}
              visible={showPropertyTable}
              onClose={handleClose}
            />
          </div>
        </Drawer>
      </Content>
    </div>
  );
});

export default DelinquencyIndex;